import { ErrorState, IconTitle, Loading, StatsCard } from '@dec/shared';
import { FileBarGraph, FileEarmarkText } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { useTaxReturnRecent } from '../hooks/useTaxReturnRecent';
import { type TaxReturnSummary } from '../models/TaxReturn';

export const TaxReturnRecentCard = () => {
  const { t } = useTranslation();
  const { data: stats, isLoading, error, refetch } = useTaxReturnRecent();

  return (
    <div>
      <div className="card">
        <div className="card-header bg-soft">
          <IconTitle
            title={t('dashboard.taxReturns')}
            icon={FileBarGraph}
            subtitle={t('dashboard.taxReturnsRecent')}
          />
        </div>
        <div className="card-body">
          {isLoading && <Loading />}

          {error && <ErrorState onRetry={() => void refetch()} />}

          {!isLoading && !error && (
            <div className="row">
              {(stats ?? []).map((item: TaxReturnSummary) => (
                <div className="col-12 col-md-12 col-xxl-6 mb-2" key={item.id}>
                  <StatsCard
                    title={item.taxpayer.name}
                    subtitle={item.formVersion?.form.name ?? ''}
                    valueDate={item.taxReturnDate}
                    type="text"
                    value={item.period}
                    icon={FileEarmarkText}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
